import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTown, type UpdateTownPayload } from '@/services/admin/towns';

export const useUpdateTownMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      siteType,
      id,
      data,
    }: {
      siteType: string;
      id: number;
      data: UpdateTownPayload;
    }) => updateTown(siteType, id, data),
    meta: { suppressNotFoundToast: true },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'town-detail', variables.siteType, variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ['towns'] });
    },
  });
};
